import React from 'react';
import Header from './Header';
import Footer from './Footer';

const DietarySupplements = () => {
    const rawHtml = `
        <style>
            .form-control::placeholder {
                color: white !important;
                opacity: 0.7;
            }
            .form-control:-ms-input-placeholder {
                color: white !important;
                opacity: 0.7;
            }
            .form-control::-ms-input-placeholder {
                color: white !important;
                opacity: 0.7;
            }
            .accordion-item {
                border: 1px solid rgba(0,0,0,.125);
                margin-bottom: 1rem;
                border-radius: 0.5rem !important;
                overflow: hidden;
                box-shadow: 0 2px 4px rgba(0,0,0,.05);
                transition: all 0.3s ease;
            }
            .accordion-item:hover {
                box-shadow: 0 4px 8px rgba(0,0,0,.1);
                transform: translateY(-2px);
            }
            .accordion-button {
                padding: 1.25rem;
                font-weight: 600;
                font-size: 1.1rem;
                color: #333;
                background-color: #f8f9fa;
                border: none;
                position: relative;
            }
            .accordion-button:not(.collapsed) {
                color: #fff;
                background-color: var(--cnvs-themecolor, #2E3192);
                box-shadow: none;
            }
            .accordion-button:not(.collapsed)::after {
                filter: brightness(0) invert(1);
            }
            .accordion-button:focus {
                box-shadow: none;
                border-color: rgba(0,0,0,.125);
            }
            .accordion-body {
                padding: 1.5rem;
                background-color: #fff;
            }
            .table {
                margin-bottom: 0;
            }
            .table thead th {
                background-color: #f8f9fa;
                border-bottom: 2px solid #dee2e6;
                font-weight: 600;
                text-transform: uppercase;
                font-size: 0.85rem;
                letter-spacing: 0.5px;
            }
            .table tbody td {
                vertical-align: middle;
                font-size: 0.95rem;
            }
            .table tbody tr:hover {
                background-color: rgba(0,0,0,.02);
            }
        </style>

        <!-- Document Wrapper -->
        <div id="wrapper">
            <!-- Hero Section -->
            <section id="slider" class="slider-element include-header" style="background: linear-gradient(90deg, rgba(34, 193, 195, 0.06), rgba(253, 187, 45, 0.1));">
                <div class="container mt-lg-6">
                    <div class="row justify-content-between align-items-center py-lg-6 py-5">
                        <div class="col-lg-5 mb-4 mb-lg-0">
                            <img src="demos/doctors/images/icons/wave.svg" alt="..." class="position-absolute top-0 start-0 translate-middle d-none d-md-block" width="50">
                            <h2 class="display-3 fw-bold color all-ts">Explore Our <span class="underliner nocolor viewport-detect" data-delay="1000">Dietary Supplements</span></h2>
                            <p>Discover our comprehensive range of dietary supplements for your health and wellness</p>
                            <a href="#products" class="button py-3 px-4 bg-color-2 color h-bg-color h-text-light rounded mx-0">View Products<i class="bi-arrow-right ms-2 me-0"></i></a>
                        </div>
                        <div class="col-lg-6">
                            <!-- Gallery -->
                            <div class="row align-items-center g-4">
                                <div class="col-6">
                                    <img src="https://i.pinimg.com/736x/2a/0a/0c/2a0a0c1e9f2df4591d14645aa2b39a28.jpg" alt="Image" class="object-cover rounded-6">
                                </div>
                                <div class="col-6">
                                    <img src="demos/doctors/images/hero/r2.jpg" alt="Image" class="object-cover rounded-6 mb-4">
                                    <img src="demos/doctors/images/hero/r3.jpg" alt="Image" class="object-cover rounded-6">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <!-- Content -->
            <section id="content">
                <div class="content-wrap py-0">
                    <!-- Products Section -->
                    <div id="products" class="section bg-transparent">
                        <div class="container">
                            <div class="row justify-content-center mb-4">
                                <div class="col-md-9 text-center">
                                    <h2 class="display-4 mb-3">Our Dietary Supplements Range</h2>
                                    <p>Discover our comprehensive range of dietary supplements for optimal health and wellness</p>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-lg-12">
                                    <div class="accordion">
                                        <!-- DIETARY SUPPLEMENTS -->
                                        <div class="accordion-item">
                                            <h2 class="accordion-header">
                                                <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#dietarysupplements">
                                                    <i class="bi bi-capsule me-2"></i>DIETARY SUPPLEMENTS
                                                </button>
                                            </h2>
                                            <div id="dietarysupplements" class="accordion-collapse collapse show">
                                                <div class="accordion-body">
                                                    <div class="table-responsive">
                                                        <table class="table table-bordered">
                                                            <thead>
                                                                <tr>
                                                                    <th>PRODUCT NAME</th>
                                                                    <th>FORMULATION</th>
                                                                    <th>PACKAGING</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr>
                                                                    <td>Triple Calcium Tablets</td>
                                                                    <td>Calcium Carbonate, Calcium Citrate Malate, Coral Calcium</td>
                                                                    <td>10x10, 10x1x10 Alu-Alu/Blister</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Multivitamins + Multiminerals + Antioxidants</td>
                                                                    <td>Tablets / Capsules</td>
                                                                    <td>10x10, 10x1x10 Alu-Alu/Blister</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Multivitamins + Multiminerals + Antioxidants with Essential Amino Acid and Ginseng</td>
                                                                    <td>Tablets / Capsules</td>
                                                                    <td>10x10, 10x1x10 Alu-Alu/Blister</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Multivitamin Tablets for Men & Women with Probiotics</td>
                                                                    <td>Tablets</td>
                                                                    <td>10x10, 10x1x10 Alu-Alu/Blister</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Men 50+ Multivitamin</td>
                                                                    <td>Multi minerals, Immunity Boosters, for Energy & Eye Health</td>
                                                                    <td>10x10, 10x1x10 Alu-Alu/Blister</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Omega 3 with multivitamins</td>
                                                                    <td>Tablets</td>
                                                                    <td>10x10, 10x1x10 Alu-Alu/Blister</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Vitamin C Complex 1000 mg</td>
                                                                    <td>Immunity Support Formula With RoseHip, Bioflavonoid Complex & Zinc For Women and Men</td>
                                                                    <td>10x10, 10x1x10 Alu-Alu/Blister</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Ferrous Ascorbate + Folic Acid</td>
                                                                    <td>Tablets</td>
                                                                    <td>10x10, 10x1x10 Alu-Alu/Blister</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Glucosamine, MSM, Chondroitin sulfate with Calcium & Vitamin D</td>
                                                                    <td>Tablets</td>
                                                                    <td>10x10, 10x1x10 Alu-Alu/Blister</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Hair Vitamins with DHT blocker</td>
                                                                    <td>Tablets / Capsules</td>
                                                                    <td>10x10, 10x1x10 Alu-Alu/Blister</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Co-enzyme Q10 with vitamin & Lycopene</td>
                                                                    <td>Tablets</td>
                                                                    <td>10x10, 10x1x10 Alu-Alu/Blister</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>L Methyl Folate (Quatrefoilic) with Vitamins and DHA</td>
                                                                    <td>Tablets</td>
                                                                    <td>10x10, 10x1x10 Alu-Alu/Blister</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Collagen Peptide + vitamin C</td>
                                                                    <td>Tablets</td>
                                                                    <td>10x10, 10x1x10 Alu-Alu/Blister</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Co-enzyme Q10 with Astaxanthin</td>
                                                                    <td>Tablets</td>
                                                                    <td>10x10, 10x1x10 Alu-Alu/Blister</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Alpha Lipoic Acid + Folic Acid + vitamin B6</td>
                                                                    <td>Tablets</td>
                                                                    <td>10x10, 10x1x10 Alu-Alu/Blister</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Ferrous Ascorbate + Folic Acid + Zinc Sulfate</td>
                                                                    <td>Tablets</td>
                                                                    <td>10x10, 10x1x10 Alu-Alu/Blister</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Spirulina</td>
                                                                    <td>Tablets</td>
                                                                    <td>10x10, 10x1x10 Alu-Alu/Blister</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Lycopene + Antioxidant</td>
                                                                    <td>Tablets / Capsules</td>
                                                                    <td>10x10, 10x1x10 Alu-Alu/Blister</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Moringa Oleifera + Multivitamin</td>
                                                                    <td>Tablet / Capsules</td>
                                                                    <td>10x10, 10x1x10 Alu-Alu/Blister</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Rosehip Extract</td>
                                                                    <td>Tablets / Capsules</td>
                                                                    <td>10x10, 10x1x10 Alu-Alu/Blister</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Curcumin, vitamin C & Omega-3 Fatty Acid</td>
                                                                    <td>Tablets</td>
                                                                    <td>10x10, 10x1x10 Alu-Alu/Blister</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Glutathione, Alpha Lipoic Acid + Grape seed Extract</td>
                                                                    <td>Tablets</td>
                                                                    <td>10x10, 10x1x10 Alu-Alu/Blister</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Ashwagandha KSM 66 Extract</td>
                                                                    <td>Tablets / Capsules</td>
                                                                    <td>10x10, 10x1x10 Alu-Alu/Blister</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Ferrous Bisglycinate, Folic Acid, Vitamin C and Vitamin B12</td>
                                                                    <td>Tablets</td>
                                                                    <td>10x10, 10x1x10 Alu-Alu/Blister</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Biotin, L-Cysteine, Zinc Oxide, Mangenese sulphate Monohydrate, Cupric acid, sodium selenate</td>
                                                                    <td>Tablets</td>
                                                                    <td>10x10, 10x1x10 Alu-Alu/Blister</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Curcuma longa powder, Curcumin Extract, Ginger Extract with black pepper extract</td>
                                                                    <td>Tablets</td>
                                                                    <td>10x10, 10x1x10 Alu-Alu/Blister</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Quercetin</td>
                                                                    <td>Tablets / Capsules</td>
                                                                    <td>10x10, 10x1x10 Alu-Alu/Blister</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Resveratrol 500mg</td>
                                                                    <td>Capsules</td>
                                                                    <td>10x10, 10x1x10 Alu-Alu/Blister</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>B-Nicotanimide Mononucleotide (NMN Uthever)</td>
                                                                    <td>Capsules</td>
                                                                    <td>10x10, 10x1x10 Alu-Alu/Blister</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Himalayan Natural Shilajit</td>
                                                                    <td>Tablets / Capsules / Raisin</td>
                                                                    <td>10x10, 10x1x10 Alu-Alu/Blister</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Calcium alpha ketoglutarate</td>
                                                                    <td>Capsules</td>
                                                                    <td>10x10, 10x1x10 Alu-Alu/Blister</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Cerebroprotein hydrolysate 90 mg</td>
                                                                    <td>Tablets / Capsules</td>
                                                                    <td>10x10, 10x1x10 Alu-Alu/Blister</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Papain, Bromelain, Serratiopeptidase, Chymotripsin Enzymes</td>
                                                                    <td>Tablets / Capsules</td>
                                                                    <td>10x10, 10x1x10 Alu-Alu/Blister</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Lutein, Zeaxanthin, Bilberry Extract</td>
                                                                    <td>Tablets / Capsules</td>
                                                                    <td>10x10, 10x1x10 Alu-Alu/Blister</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>D-Mannose and Cranberry Extract</td>
                                                                    <td>Tablets</td>
                                                                    <td>10x10, 10x1x10 Alu-Alu/Blister</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Hydrolysed Collagen Complex</td>
                                                                    <td>Tablets</td>
                                                                    <td>10x10, 10x1x10 Alu-Alu/Blister</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>L-Glutathione (Opitac)</td>
                                                                    <td>L-Glutathione, Reserveratrol, ALA, Vitamin C & E, Biotin Capsules</td>
                                                                    <td>10x10, 10x1x10 Alu-Alu/Blister</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>L-Arginine, L-Citrulline with Grape seed Extract</td>
                                                                    <td>Capsules</td>
                                                                    <td>10x10, 10x1x10 Alu-Alu/Blister</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Calcium, Magnesium and Zinc with Vitamin D3</td>
                                                                    <td>Tablets</td>
                                                                    <td>10x10, 10x1x10 Alu-Alu/Blister</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Boswellia Serrata</td>
                                                                    <td>Capsules</td>
                                                                    <td>10x10, 10x1x10 Alu-Alu/Blister</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>French Grape Seed Extract</td>
                                                                    <td>Capsules</td>
                                                                    <td>10x10, 10x1x10 Alu-Alu/Blister</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Korean Red Ginseng 1000mg For Men</td>
                                                                    <td>Capsules</td>
                                                                    <td>10x10, 10x1x10 Alu-Alu/Blister</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Brain Supplement</td>
                                                                    <td>Alpha GPC, Bacopa Monnieri, L-Theanine, Phosphatidylserine Capsules</td>
                                                                    <td>10x10, 10x1x10 Alu-Alu/Blister</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Keto Supplements for Mental Clarity & Focus</td>
                                                                    <td>Calcium BHB, Magnesium BHB, Apple cider vinegar and Raspberry Ketons Capsules</td>
                                                                    <td>10x10, 10x1x10 Alu-Alu/Blister</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Sea Kelp Capsules</td>
                                                                    <td>Good for Thyroid and Natural source of Iodine</td>
                                                                    <td>10x10, 10x1x10 Alu-Alu/Blister</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Citicholine 500 mg</td>
                                                                    <td>Tablets / Capsules</td>
                                                                    <td>10x10, 10x1x10 Alu-Alu/Blister</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Beta Glucans</td>
                                                                    <td>Capsules</td>
                                                                    <td>10x10, 10x1x10 Alu-Alu/Blister</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Pre and Pro-Biotic Capsules with Zinc</td>
                                                                    <td>Capsules</td>
                                                                    <td>10x10, 10x1x10 Alu-Alu/Blister</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Beta Carotene with Multivitamin and Multimineral</td>
                                                                    <td>Capsules</td>
                                                                    <td>10x10, 10x1x10 Alu-Alu/Blister</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>B-Complex with Lactic Acid Bacillus</td>
                                                                    <td>Capsules</td>
                                                                    <td>10x10, 10x1x10 Alu-Alu/Blister</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>L-Arginine, Tribulus Terrestris, Mucuna Pruriens, Ginkgo Biloba, Zinc, Yohimbe Bark</td>
                                                                    <td>Capsules</td>
                                                                    <td>10x10, 10x1x10 Alu-Alu/Blister</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Collagen Peptide type 1,Sodium Hyaluronate, Chondroitin Sulfate & Vitamin C</td>
                                                                    <td>Tablets</td>
                                                                    <td>10x10, 10x1x10 Alu-Alu/Blister</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Soy Isoflavones 40%, Calcitriol, Vitamin K2, Calcium citrate, Calcium Aspartate, Calcium orotate</td>
                                                                    <td>Tablets</td>
                                                                    <td>10x10, 10x1x10 Alu-Alu/Blister</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Horny goat weed, Maca Root, Safed musali, Shilajit, Ashwagandha, Asparagus, Gokharu</td>
                                                                    <td>Capsules</td>
                                                                    <td>10x10, 10x1x10 Alu-Alu/Blister</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Spermidine HCl</td>
                                                                    <td>Tablets / Capsules</td>
                                                                    <td>10x10, 10x1x10 Alu-Alu/Blister</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Apigenin (Bioflavonoid Found in Chamomile Tea) Supplement</td>
                                                                    <td>Capsules</td>
                                                                    <td>10x10, 10x1x10 Alu-Alu/Blister</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Valerian Root Extract, lavender extract, Chamomile</td>
                                                                    <td>Capsules</td>
                                                                    <td>10x10, 10x1x10 Alu-Alu/Blister</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Berberine HCL</td>
                                                                    <td>Capsules</td>
                                                                    <td>10x10, 10x1x10 Alu-Alu/Blister</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Vitamin D3 60000 IU chewable</td>
                                                                    <td>Tablets</td>
                                                                    <td>10x10, 10x1x10 Alu-Alu/Blister</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Bacillus Subtilis 2 Billion CFU</td>
                                                                    <td>Capsules</td>
                                                                    <td>10x10, 10x1x10 Alu-Alu/Blister</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Saccharomyces boulardii and Lactobacillus Rhamnosus (LGG)</td>
                                                                    <td>Capsules</td>
                                                                    <td>10x10, 10x1x10 Alu-Alu/Blister</td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    `;

    return (
        <>
            <Header />
            <div dangerouslySetInnerHTML={{ __html: rawHtml }} />
            <Footer />
        </>
    );
};

export default DietarySupplements; 